import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SmsComponent } from './sms/sms.component';
import { WhitelistListComponent } from './whitelist-list/whitelist-list.component';

const routes: Routes = [
  {
    path : "",
    component: WhitelistListComponent
  },
  {
    path : "add-sms",
    component: SmsComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SmsRoutingModule { }
